

export function loadFonts(frameDocument, options) {
  let headEl = frameDocument.getElementsByTagName('head')[0];
  const gFontOptions = options.filter((option) => option.is_google_font);
  gFontOptions.forEach((option) => {
    let accessor = option.family.toLowerCase().replaceAll(" ", "_");
    let elementId = `ov_font_${accessor}`;

    let existingTag = frameDocument.getElementById(elementId);
    if (existingTag) return;

    let tag = frameDocument.createElement('link');
    tag.id = elementId;
    tag.rel = "stylesheet";
    tag.href = `https://fonts.googleapis.com/css2?family=${option.family}`;
    headEl.appendChild(tag);
  })
}

